module.exports = __webpack_public_path__ + "img/dentino.63aff9fb.png";